import type { RangeSliderThemeStyles } from './types'

export const RANGE_SLIDER_THEMES: RangeSliderThemeStyles = {
  'neon-blue': {
    trackBackground: '#DAD9FF',
    trackForeground: '#605CFF',
  },
}
